export default class CheckoutOptions {
	checkoutKey: string;
	paymentId: string;
	containerId: string;
	language: string;
	theme: object;

	constructor(checkoutKey: string, paymentId: string, containerId: string, language: string, theme?: object) {
		this.checkoutKey = checkoutKey;
		this.paymentId = paymentId;
		this.containerId = containerId;
		this.language = language;
		this.theme = theme;
	}
}
